import { useEffect, useState } from 'react';

export const useIsElementInViewport = (ref, compare = []) => {
  const [isElementInViewport, setIsElementInViewport] = useState(false);

  useEffect(() => {
    if (ref?.current) {
      const cachedRef = ref.current;
      const observer = new IntersectionObserver(([entry]) => {
        setIsElementInViewport(entry?.isIntersecting);
      });

      observer.observe(cachedRef);

      return () => {
        observer.unobserve(cachedRef);
      };
    }
  }, [ref.current, JSON.stringify(compare)]);

  return isElementInViewport;
};
